/**
 * Relationship Manager (role=manager) portal shell.
 */
import { Navigate, useLocation } from "react-router-dom";
import { BriefcaseBusiness } from "lucide-react";
import { useMe } from "@/hooks/useAuth";
import { managerNav } from "./managerNav";
import { AppShell, ShellFooterCard, ShellSkeleton, type ShellNavItem } from "./AppShell";

const nav: ShellNavItem[] = managerNav.map((i) => ({ ...i, end: i.to === "/manager/dashboard" }));

export function ManagerShell() {
  const { data: me, isPending, isError } = useMe();
  const location = useLocation();

  if (isPending) return <ShellSkeleton items={7} />;
  if (isError || !me) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (me.role !== "manager") {
    if (me.role === "platform_admin") return <Navigate to="/platform/dashboard" replace />;
    if (me.role === "admin") return <Navigate to="/admin/dashboard" replace />;
    if (me.role === "ib") return <Navigate to="/ib/dashboard" replace />;
    return <Navigate to="/trader/dashboard" replace />;
  }

  return (
    <AppShell
      nav={nav}
      storageKey="manager"
      maxWidth="max-w-[1440px]"
      footer={<ShellFooterCard icon={BriefcaseBusiness} title="Relationship Manager" subtitle={me.fullName ?? me.email} />}
    />
  );
}
